<template>
  <div id="head">
    <transition  name="slide-fade">
      <div :class="className" ref="leftmenu">
        <div class="left-logo">
          <img src="../../assets/img/logo-hyb.png" alt="好运吧" />
          <br />
          <span>好运吧</span>
        </div>
        <ul   class="menu">
          <li v-for="(menu,index) in menuList">
            <a @click="goPage(index)">
              <div class="menu-logo">
                <img :src="menu.logo" alt />
              </div>
              <div class="menu-content">
                <span>{{menu.name}}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </transition>
    <div @click="hideMenu" :class="showflag" ref="menuBlak"></div>

    <div class="head">
      <div v-if="tuiShow" class="head-left" @click="showMenu">
        <a class="hym-head-left"></a>
      </div>
       <div v-if="!tuiShow" class="head-left-w">
      </div>
      <div class="head-title">{{ vuetiltle }}</div>
      <div class="head-right" v-if="!tuiShow" @click="closeviwe">关闭</div>
      <div class="head-right" v-if="tuiShow" @click="exitUser">退出</div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "",
  data() {
    return {
      menuList: [
        { logo: "../../static/img/shouye-1.png", name: "首页", url: "/" },
        {
          logo: "../../static/img/shouye-5.png",
          name: "管理中心",
          url: "/userCenters"
        },
        {
          logo: "../../static/img/shouye-2.png",
          name: "下载伪装APP",
          url: "/downapp"
        },
        { logo: "../../static/img/shouye-3.png", name: "VIP服务", url: "/vip" },
        {
          logo: "../../static/img/shouye-4.png",
          name: "私人定制",
          url: "/personal"
        },
        {
          logo: "../../static/img/qml-logo@2x.png",
          name: "无伪装版本下载",
          url: "/app/qmldown"
        },
        {
          logo: "../../static/img/shouye-4.png",
          name: "联系客服",
          url: "/contactKF"
        }
      ],
      showflag: true,
      showflag: "menu-black-none",
      className: "leftNone",
      vuetiltle: this.title,
      tuiShow: false
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    console.log("本地缓存token：" + token);
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token != null && token != "") {
      this.tuiShow = true;
    }
    var appFlag = this.getAppFlag;
    console.log("appFlag:" + appFlag);
    if (appFlag == true) {
      this.tuiShow = false;
    }else{
      this.menuList = [
        { logo: "../../static/img/shouye-1.png", name: "首页", url: "/" },
        // {
        //   logo: "../../static/img/shouye-5.png",
        //   name: "管理中心",
        //   url: "/userCenters"
        // },
        {
          logo: "../../static/img/shouye-2.png",
          name: "下载伪装APP",
          url: "/downapp"
        },
        { logo: "../../static/img/shouye-3.png", name: "VIP服务", url: "/vip" },
        {
          logo: "../../static/img/shouye-4.png",
          name: "私人定制",
          url: "/personal"
        },
         {
          logo: "../../static/img/shouye-6.png",
          name: "联系客服",
          url: "/contactKF"
        }
        ];
    }
  },
  props: {
    title: String
  },
  methods: {
    closeviwe: function() {
      window.location.href = "hqml://closeWindow";
    },
    goPage: function(num) {
      this.hideMenu();
      this.$router.push(this.menuList[num].url);
    },
    hideMenu: function() {
      console.log("隐藏菜单");
      this.className = "right";
      this.showflag = "menu-black-none";
      var t;
      clearTimeout(t);
      t = setTimeout(() => {
        console.log("去掉菜单样式");
        this.className = "menuHide";
        this.showflag = "menuHide";
      }, 1500);
    },
    showMenu: function() {
      console.log("显示菜单");
      this.showflag = "menu-black";
      this.className = "left";
    },
    exitUser: function() {
      this.$axiosHttp({
        method: "POST",
        url: api.qml.exitUser,
        data: {}
      })
        .then(res => {
          if (res.code == 0) {
            tips.toast("退出成功");
            store.commit(types.SET_USERINFO, null);
            store.commit(types.SET_USERLIST, null);
            store.commit(types.LOGIN, null);
            store.commit(types.SET_LOGIN_OBJ, null);
            localStorage.removeItem("token");

            this.$router.push("/logins");
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getAppFlag"
    ])
  }
};
</script>
<style scoped>
.head {
  left: 0;
  width: 100%;
  height: 88px;
  height: calc(88px + constant(safe-area-inset-top));
  height: calc(88px + env(safe-area-inset-top));
  padding: 7px 3px;
  padding-top: calc(7px + constant(safe-area-inset-top));
  padding-top: calc(7px + env(safe-area-inset-top));
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  overflow: hidden;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 996;
  color: #fff;
  background-color: #181723;
  -webkit-transition-property: all;
  transition-property: all;
}
.head-left {
  position: relative;
  width: 32px;
  height: 30px;
  margin: 30px 0px 28px 32px;
  word-break: keep-all;
  white-space: pre;
  background: url("../../assets/img/head-nav.png");
  background-size: 100% 100%;
}
.head-left-w {
  position: relative;
  width: 32px;
  height: 30px;
  margin: 30px 0px 28px 32px;
  word-break: keep-all;
  white-space: pre;
  background-size: 100% 100%;
}
.head-left img {
  width: 32px;
  height: 30px;
}

.head-title {
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: rgba(24, 23, 35, 1);
  margin: 18px 0px 20px 0px;
  width: 252px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
}

.head-right {
  position: relative;
  width: auto;
  margin: 5px 13px 14px 16px;
  word-break: keep-all;
  white-space: pre;
  float: right;
  width: 48px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 34px;
  margin: 22px 32px 32px 0px;
}

.leftNone {
  width: 462px;
  height: 100%;
  background: rgba(30, 31, 49, 1);
  z-index: 10000;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 998;
  color: #fff;
  -webkit-transition-property: all;
  transition-property: all;
  position: absolute;
  display: none;
}

.left {
  width: 462px;
  height: 100%;
  background: rgba(30, 31, 49, 1);
  z-index: 10000;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 998;
  color: #fff;
  -webkit-transition-property: all;
  transition-property: all;
  position: absolute;
  transition: 1.5s;
  animation: bounceInLeft 1.5s 1 cubic-bezier(0.215, 0.61, 0.355, 1);
}

@keyframes bounceInLeft {
  0% {
    transform: translate3d(-300px, 0, 0);
  }
  60% {
    /*  opacity: 1;*/
    transform: translate3d(0, 0, 0);
  }
  75% {
    transform: translate3d(0px, 0, 0);
  }
  90% {
    transform: translate3d(0px, 0, 0);
  }
  100% {
    transform: none;
  }
}

.right {
  width: 462px;
  height: 100%;
  background: rgba(30, 31, 49, 1);
  z-index: 10000;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 998;
  color: #fff;
  -webkit-transition-property: all;
  transition-property: all;
  position: absolute;
  transition: 1.5s;
  animation: bounceOutLeft 1.5s 1 cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

@keyframes bounceOutLeft {
  0% {
    -webkit-transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-350px);
  }
}

.menu-black {
  position: fixed;
  z-index: 997;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7;
  transition-duration: 1s;
}

.menu-black-none {
  position: fixed;
  z-index: -1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7;
  transition-duration: 1s;
  animation: bounceOutLeftB 1.5s 1 cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
}

@keyframes bounceOutLeftB {
  0% {
  }
  100% {
    opacity: 0;
  }
}

.left-logo {
  width: 114px;
  height: 176px;
  margin: 80px 178px 50px 170px;
}

.left-logo img {
  width: 114px;
  height: 114px;
}

.left-logo span {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 70px;
}
.menu {
  width: 100%;
  height: auto;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  list-style: none;
  text-align: left;
  margin: 0;
  padding: 0;
}

.menu li {
  width: 100%;
  height: 48px;
  margin: 38px 0px 0px 36px;
}
.menu li div {
  height: 48px;
  float: left;
}
.menu li div:last-child {
  margin-left: 30px;
}
.menu li img {
  width: 48px;
  height: 48px;
}
.menu li span {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  opacity: 1;
  transform: translateX(0px);
  transition: all 0.4s;
}

.menuHide {
  display: none;
}
.showContent {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/common/head.vue